/* global axios */
import ApiClient from './ApiClient';

class SensitiveWordsAPI extends ApiClient {
  constructor() {
    super('sensitive_words', { accountScoped: true });
  }

  get({ search, page, perPage }) {
    const pageUrl = `${this.url}?page=${page}&perPage=${perPage}`;
    const url = search ? `${pageUrl}&search=${search}` : pageUrl;
    return axios.get(url);
  }

  categories() {
    return axios.get(`${this.url}/categories`);
  }

  import(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new SensitiveWordsAPI();
